var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-box',{attrs:{"collapseData":_vm.dataByProjectCategory,"spinning":_vm.spinning},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var requirement = ref.record;
return [_c('requirement-item',{key:requirement.id,attrs:{"requirement":requirement,"active":_vm.activeId === requirement.id},on:{"click":function($event){return _vm.viewDetail(requirement)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }